import { render, staticRenderFns } from "./addLocation.vue?vue&type=template&id=6c52e4d0&"
import script from "./addLocation.vue?vue&type=script&lang=js&"
export * from "./addLocation.vue?vue&type=script&lang=js&"
import style0 from "./addLocation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports